import EMITTER from "@core/emitter";
import { INVIEW_ENTER } from "@scroll/constants";
import { hideCursor, showCursor } from "@utils/cursor";
import { $, rect } from "@utils/dom";
import { on, off } from "@utils/listener";
import { mobile } from "@utils/mobile";
import RAF, { AFTER_SCROLL } from "@utils/raf";
import ResizeOrientation, { BEFORE_SCROLL_UPDATE } from "@utils/resize";

const HOVER_CLASSNAME = '--hover';

class VideoControls {
  constructor(el, target) {
    this.el = el;
    this.target = target;
    this.btn = $('.video-controls__btn', this.el);
    this.btn_icon = $('.btn__icon', this.btn);

    this._data = { x: 0, y: 0, event: null, scrollY: 0, offsetX: 0, offsetY: 0, marginTop: 0, marginLeft: 0 };
    this._inView = false;
    this._raf = null;

    this._onScrollCall = this._onScrollCall.bind(this);
    this._onScroll = this._onScroll.bind(this);
    this._onResize = this._onResize.bind(this);
    this._onMouseMove = this._onMouseMove.bind(this);
    this._onMouseEnter = this._onMouseEnter.bind(this);
    this._onMouseLeave = this._onMouseLeave.bind(this);
    this._onRAF = this._onRAF.bind(this);

    this.init();
  }

  init() {
    if( mobile ) return;

    this._raf = RAF.add(this._onRAF, AFTER_SCROLL, false);

    this._bindEvents();
    this._onResize();
  }
  destroy() {
    this._unbindEvents();
    showCursor();

    this.el = null;
    this.target = null;
    this.btn = null;
    this.btn_icon = null;

    this._data = null;
    this._inView = null;
    this._raf = null;

    this._onScrollCall = null;
    this._onScroll = null;
    this._onResize = null;
    this._onMouseMove = null;
    this._onMouseEnter = null;
    this._onMouseLeave = null;
    this._onRAF = null;
  }

  _bindEvents() {
    ResizeOrientation.add(this._onResize, BEFORE_SCROLL_UPDATE);
    EMITTER.on('SiteScroll.video-controls', this._onScrollCall);
    EMITTER.on('SiteScroll.scroll', this._onScroll);

    on(window, 'mousemove', this._onMouseMove);
    on(this.target, 'mouseenter', this._onMouseEnter);
    on(this.target, 'mouseleave', this._onMouseLeave);
  }
  _unbindEvents() {
    ResizeOrientation.remove(this._onResize);

    EMITTER.off('SiteScroll.video-controls', this._onScrollCall);
    EMITTER.off('SiteScroll.scroll', this._onScroll);

    off(window, 'mousemove', this._onMouseMove);
    off(this.target, 'mouseenter', this._onMouseEnter);
    off(this.target, 'mouseleave', this._onMouseLeave);

    RAF.remove(this._onRAF);
  }

  _onScrollCall(direction, obj) {
    if( obj.el !== this.el ) return;

    // if inView status hasn't changed, stop here
    const inView = direction === INVIEW_ENTER;
    if( this._inView === inView ) return;

    this._inView = inView;

    // start/stop RAF
    this._raf(this._inView);
  }
  _onScroll({ y }) { this._data.scrollY = y; }
  _onResize() {
    const { x, y } = rect(this.el);

    this._data.offsetX = x;
    this._data.offsetY = y + this._data.scrollY;
    this._data.marginTop = rect(this.btn).height / 2;
    this._data.marginLeft = rect(this.btn_icon || this.btn).width / 2
  }
  _onMouseMove(event) {
    this._data.event = event;
  }
  _onMouseEnter() {
    this.el.classList.add(HOVER_CLASSNAME);
    hideCursor();
  }
  _onMouseLeave() {
    this.el.classList.remove(HOVER_CLASSNAME);
    showCursor();
  }
  _onRAF(delta) {
    const { event, offsetX, offsetY, scrollY, marginLeft, marginTop } = this._data;
    if( !event ) return;

    this._data.x = event.clientX - offsetX - marginLeft;
    this._data.y = event.clientY - offsetY + scrollY - marginTop;

    const { x, y } = this._data;
    this.btn.style.transform = `translate3d(${x}px, ${y}px, 0px)`;
  }
}

export default VideoControls;
